import { Type } from 'react-bootstrap-table2-editor';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import * as Helpers from '../Helpers/DatatableHelpers';
import * as DataFormat from '../../../../../Common/Scripts';
import { numericEditRenderer } from '../Helpers/Editors';

const FeesConfigColumns = onStartEdit => [
	{ dataField: 'id_type', text: 'id_type', hidden: true, csvExport: false },
	{
		dataField: 'appointmentTypeInstanceId',
		text: 'AppointmentTypeInstance',
		hidden: true,
		csvExport: false
	},
	{
		dataField: 'currentYear',
		text: 'Year',
		editable: false,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'type',
		text: 'Type',
		editable: false,
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide'
	},
	{ dataField: 'markingTeamId', text: 'ID', hidden: true }, //sort: true, headerStyle: {cursor: "pointer"}
	{
		dataField: 'title',
		text: 'Marking Team Title',
		headerClasses: 'th-title-td',
		sort: true,
		editable: false
	},
	{
		dataField: 'markingTeamCode',
		text: 'Code',
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		sort: true,
		editable: false,
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'hourlyRate',
		text: 'Hourly Rate',
		headerClasses: 'th-td-xss',
		classes: 'tr-td-overflow-hide',
		sort: true,
		type: 'number',
		formatter: cell => Helpers.formatNumericValue(cell),
		validator: newVal => Helpers.validateNumberValue(newVal),
		editorRenderer: numericEditRenderer(onStartEdit)
	},
	{
		dataField: 'throughputRate',
		text: 'Throughput Rate',
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		sort: true,
		type: 'number',
		formatter: cell => Helpers.formatNumericValue(cell),
		validator: newVal => Helpers.validateNumberValue(newVal),
		editorRenderer: numericEditRenderer(onStartEdit)
	},
	{
		dataField: 'throughputRateConfirmed',
		text: 'Throughput Confirmed',
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		sort: true,
		formatter: cell => {
			if (!cell) return 'No';
			return cell;
		},
		editor: {
			type: Type.SELECT,
			defaultValue: 'No',
			options: [
				{ label: 'No', value: 'No' },
				{ label: 'Yes', value: 'Yes' },
				{ label: 'On Hold', value: 'On Hold' }
			]
		}
	},
	{
		dataField: 'scriptFee',
		text: 'Script Fee',
		sort: true,
		type: 'number',
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		formatter: cell => Helpers.formatNumericValue(cell),
		validator: newVal => Helpers.validateNumberValue(newVal),
		editorRenderer: numericEditRenderer(onStartEdit)
	},
	{
		dataField: 'trainingFee',
		text: 'Training Fee',
		sort: true,
		type: 'number',
		headerClasses: 'th-td-xss',
		classes: 'tr-td-overflow-hide',
		formatter: cell => Helpers.formatNumericValue(cell),
		validator: newVal => Helpers.validateNumberValue(newVal),
		editorRenderer: numericEditRenderer(onStartEdit)
	},
	{
		dataField: 'sessionRateCurrentYear',
		text: 'Session Rate',
		sort: true,
		type: 'number',
		headerClasses: 'th-td-xss',
		classes: 'tr-td-overflow-hide',
		formatter: cell => Helpers.formatNumericValue(cell),
		validator: newVal => Helpers.validateNumberValue(newVal),
		editorRenderer: numericEditRenderer(onStartEdit)
	},
	{
		dataField: 'sessionFeeText',
		text: 'Session Fee Text',
		sort: true,
		headerClasses: 'th-td-md',
		validator: newVal => Helpers.fieldLengthValidation(newVal)
	}
];

export default FeesConfigColumns;
